import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import type { FillPathway } from '../../../../contexts/fill';
import {
    type PatientChoiceInput,
    SavePatientChoicesDocument,
} from '../../../../graphql/generated/graphql';

export const usePatientChoiceMutation = ({ drxId }: { drxId: string }) => {
    const [savePatientChoices] = useMutation(SavePatientChoicesDocument);

    return useCallback(
        ({
            pathway,
            originalPathway,
            subPathway,
            additionalChoices = [],
        }: {
            pathway: FillPathway | null;
            originalPathway: FillPathway | null;
            subPathway: string | null;
            additionalChoices?: PatientChoiceInput[];
        }) => {
            const choices = [
                !!pathway && {
                    patientChoiceKey: 'pathway',
                    patientChoiceValue: pathway,
                },
                !!originalPathway && {
                    patientChoiceKey: 'original-pathway',
                    patientChoiceValue: originalPathway,
                },
                !!subPathway && {
                    patientChoiceKey: 'sub-pathway',
                    patientChoiceValue: subPathway,
                },
                ...additionalChoices,
            ].filter(Boolean) as PatientChoiceInput[];

            if (choices.length > 0) {
                return savePatientChoices({
                    variables: { prescriberOrderId: drxId, choices },
                });
            }
        },
        [savePatientChoices, drxId]
    );
};
